/**
 * Pre-logout cleanup registry.
 * Modules register async callbacks here; AuthContext's logout() runs them
 * all (with Promise.allSettled) BEFORE calling signOut(auth), so that any
 * authenticated RTDB/Firestore writes (e.g. chatroom presence removal) have
 * a valid token when they execute.
 */
const fns = new Set();

export const registerPreLogout   = fn => fns.add(fn);
export const unregisterPreLogout = fn => fns.delete(fn);
export const runPreLogoutCleanups = () =>
  Promise.allSettled([...fns].map(fn => fn()));
